import $ from 'jquery';
window.$ = $;
import 'waypoints/lib/noframework.waypoints';
import 'slick-slider';

$.fn.scrollTo = function(offsetTop) {
    if ($(this).length) {
        offsetTop = typeof offsetTop !== 'undefined' ? offsetTop : 0;
        var top = $(this).eq(0).offset().top-offsetTop;
        $('html, body').animate({
            scrollTop : top
        },500);
    }
};

$(document).ready(function() {
    new Waypoint({
        element: $('body > header')[0],
          handler: function(direction) {
            if (direction == 'down') {
              $('.mainnav').addClass('is-sticky');
              $('.mainnav-burger-wrapper, .logo').addClass('is-sticky');
            }
            else if (direction == 'up') {
              $('.mainnav').removeClass('is-sticky is-opened');
              $('.mainnav-burger-wrapper, .logo').removeClass('is-sticky');
            }
          },
          offset: function() {
            return -1 * ($('body > header').height() + $('section.intropage').height() - 80);
          }
    });
    $('.page').each(function() {
        var _self = this;
        new Waypoint({
            element: _self,
            handler: function(direction) {
                var links = $('[data-sexylink]'),
                    activeLink = $('[data-sexylink="'+_self.id+'"]');
                console.log(links);
                links.removeClass('active').each(function() {
                    $(this).parent().removeClass('active');
                });
                if (direction == 'down') {
                    activeLink.addClass('active').parent().addClass('active');
                }
                else if (direction == 'up') {
                    activeLink.parent().prev().addClass('active');
                }
                console.log(activeLink);
            },
            offset: function () {
                return $('.mainnav').eq(0).outerHeight();
            }
        });
    });
    $('.sexylink').on('click', function(e) {
        if ($(this).parents('.not-home').length == 0) {
            e.preventDefault();
            $('#'+$(this).attr('data-sexylink')).scrollTo(0);
            $('.mobilenav').removeClass('mobilenav--opened');
        }
    });
    $('a.showitsexy').on('click', function(e) {
      e.preventDefault();
      $('#loader').fadeIn(function() {
        $('body').css('overflow', 'hidden');
      });
      $('#overlay > div').load($(this).prop('href')+' section.page', function(response, status, xhr) {
        if ( status == 'error' ) {
          var msg = 'Sorry but there was an error: ';
          window.alert( msg + xhr.status + ' ' + xhr.statusText );
        }
        $('#overlay > div').hide();
        $('#overlay').fadeIn(function() {
          $('#overlay > div').fadeIn();
        });
        $('#loader').fadeOut();
        $('#overlay .sexyslide').slick({
            infinite: true,
            adaptiveHeight: false,
            variableWidth: true,
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });
      });

    });
    $('#closebtn').on('click', function(e) {
      e.preventDefault();
      $('#overlay > div').fadeOut(function() {
        $('body').css('overflow', '');
        $('#overlay').fadeOut().attr('aria-hidden', 'false');
      });
    });
    $('.mainnav-burger').on('click', function(e) {
        $('.mainnav').toggleClass('is-opened');
        $('.mainnav-burger-wrapper, .logo').addClass('is-sticky');
        if (!$('.mainnav').hasClass('is-opened') && $('html, body').scrollTop() < $(window).height())
          $('.mainnav-burger-wrapper, .logo').removeClass('is-sticky');
    });
    $('.mainnav').on('click', '.mainnav-el', function(e) {
        $('.mainnav').removeClass('is-opened');
    });


    $('.sexyslide').slick({
      infinite: true,
      adaptiveHeight: false,
      variableWidth: true,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });

});